import React, { useEffect, useRef, useCallback, memo } from "react";
import QuoteTab from "./QuoteTab";

function TradingViewWidget({ stockSymbol }) {
  const containerRef = useRef();

  const getExchange = useCallback(() => {
    if (stockSymbol.includes(".")) {
      const [ticker, exchange] = stockSymbol.split(".");
      switch (exchange) {
        case "NE":
          return `NEO:${ticker}`;
        case "V":
          return `TSXV:${ticker}`;
        case "CN":
          return `CSE:${ticker}`;
        case "TO":
          return `TSX:${ticker}`;
        default:
          return stockSymbol;
      }
    } else {
      return stockSymbol;
    }
  }, [stockSymbol]);

  useEffect(() => {
    const currentContainer = containerRef.current;

    if (currentContainer) {
      const loadScript = () => {
        // Remove any existing script to prevent duplicates
        const existingScript = currentContainer.querySelector("script");
        if (existingScript) {
          existingScript.remove();
        }

        // Create and configure the new script
        const script = document.createElement("script");
        script.src =
          "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
        script.type = "text/javascript";
        script.async = true;

        const widgetConfig = {
          symbols: [[getExchange(), `${getExchange()}|1D`]],
          chartOnly: false,
          width: "100%",
          height: "400",
          locale: "en",
          colorTheme: "light",
          autosize: true,
          showVolume: false,
          showMA: false,
          hideDateRanges: false,
          hideMarketStatus: false,
          hideSymbolLogo: false,
          scalePosition: "right",
          scaleMode: "Normal",
          fontFamily:
            "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
          fontSize: "12",
          noTimeScale: false,
          valuesTracking: "1",
          changeMode: "price-and-percent",
          chartType: "area",
          maLineColor: "#2962FF",
          maLineWidth: 1,
          maLength: 9,
          lineWidth: 2,
          lineType: 0,
          dateRanges: ["1d|1", "1m|30", "3m|60", "12m|1D", "60m|1W", "all|1M"],
        };

        script.innerHTML = JSON.stringify(widgetConfig);
        currentContainer.appendChild(script);
      };

      // Delay script loading until DOM is ready
      const rafId = requestAnimationFrame(loadScript);

      // Cleanup: cancel animation frame and clear container
      return () => {
        cancelAnimationFrame(rafId);
        currentContainer.innerHTML = "";
      };
    }
  }, [stockSymbol, getExchange]);

  return (
    <section
      id="stockQuote"
      className="p-4 mt-5 bg-white shadow-md rounded-lg border mb-4 pb-10"
    >
      <h2 className="text-2xl font-bold mt-5 mb-5">{`${stockSymbol.toUpperCase()} Stock Price`}</h2>
      <div
        className="tradingview-widget-container overflow-hidden rounded-xl aspect-w-16 aspect-h-9"
        ref={containerRef}
      >
        <div className="tradingview-widget-container__widget" />
      </div>
      <div className="mt-4 border rounded-xl">
        <QuoteTab stockSymbol={stockSymbol} />
      </div>
    </section>
  );
}

export default memo(TradingViewWidget);
